import { Typography } from '@mui/material';
import { Column, TableState, usePagination, useRowSelect, useSortBy, useTable } from 'react-table';
import { QuotesSummaryItem } from 'shared/types/quotesSummary';
import { quotesSummaryTableColumns } from './columns/quotes-summary-table-columns';

const defaultColumn: Partial<Column<QuotesSummaryItem>> = {
  Filter: () => null,
  Cell: ({ value = '' }) => <Typography variant='body2'>{value}</Typography>,
  disableFilters: true,
  width: 150,
  minWidth: 75,
  maxWidth: 150,
  align: 'inherit',
};

const getRowId = (row: QuotesSummaryItem) => row.id;

export function useQuotesSummaryTableInstance(
  data: QuotesSummaryItem[],
  totalCount: number,
  initialState: TableState<QuotesSummaryItem>
) {
  return useTable<QuotesSummaryItem>(
    {
      columns: quotesSummaryTableColumns,
      data,
      initialState,
      pageCount: totalCount,
      manualSortBy: true,
      manualPagination: true,
      manualFilters: true,
      defaultColumn,
      getRowId,
      autoResetFilters: false,
      autoResetPage: false,
    },
    useSortBy,
    usePagination,
    useRowSelect
  );
}
